<template>

  <portal to="modals" v-if="show">

    <div v-if="show" @click.self="close" :class="maskClass">

      <slot></slot>

    </div>

  </portal>

</template>

<script>
export default {

  name: 'VaModal',

  props: {

    show: { type: Boolean, default: false }

  },

  computed: {

    maskClass() {

      return [

        // Masking
        'fixed', 'pin', 'z-50', 'bg-smoke-light', 'overflow-auto',

        // Flexbox
        'flex', 'justify-center', 'items-center',

        // Animation
        'animated', 'faster', 'fadeIn',

      ].join(' ');

    }

  },

  methods: {

    close() {

      this.$emit('close');

    }

  },

  mounted: function () {

    document.addEventListener("keydown", (e) => {

      if (this.show && e.keyCode == 27) {

        this.close();

      }

    });

  }

}
</script>
